var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-component-container"},[_c('van-image',{staticClass:"top-img",attrs:{"width":"100%","fit":"contain","src":_vm.homeImg}}),_c('van-image',{staticClass:"top-img-level",attrs:{"width":"100%","fit":"contain","src":_vm.home2Img}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }